<template>
  <Modal :modal="modal.filter" :action="() => _trigger()">
    <ModalBody>
      <FilterContainer :label="'Date'">
        <div class="row">
          <div class="col-6">
            <selectize
              class="form-control"
              placeholder="Pilih Bulan"
              v-model="filter.month"
            >
              <option
                v-for="(month, i) in months"
                :key="month"
                v-html="month"
                :value="i"
              />
            </selectize>
          </div>
          <div class="col-6">
            <selectize
              class="form-control"
              placeholder="Pilih Tahun"
              v-model="filter.year"
            >
              <option
                v-for="year in years"
                :key="year"
                v-html="year"
                :value="year"
              />
            </selectize>
          </div>
        </div>
      </FilterContainer>
      <FilterPerusahaan
        :model="filter"
        :response="response"
        :action="() => _getDepo()"
      />
      <FilterDepo
        :model="filter"
        :response="response"
        :action="() => _getSalesman()"
      />
      <FilterSalesman :model="filter" :response="response" />
    </ModalBody>
    <ModalFooter>
      <ButtonClose :disabled="loading" :action="() => _trigger()" />
      <ButtonSave :disabled="loading" :action="() => _submit()" />
    </ModalFooter>
  </Modal>
</template>
<script>
import moment from "moment";
import helper from "@/assets/js/helper.js";
import FilterPerusahaan from "@/components/filter/filter-perusahaan.vue";
import FilterDepo from "@/components/filter/filter-depo.vue";
import FilterSalesman from "@/components/filter/filter-salesman.vue";
import FilterContainer from "@/components/filter/filter-container.vue";
import { mapState, mapActions } from "vuex";
export default {
  components: {
    FilterPerusahaan,
    FilterDepo,
    FilterSalesman,
    FilterContainer,
  },
  mixins: [helper],
  data() {
    return {
      months: [],
      years: [],
    };
  },
  computed: {
    ...mapState(["loading"]),
    ...mapState("insentif_salesman", {
      modal: (state) => state.modal,
      filter: (state) => state.filter,
      response: (state) => state.response,
    }),
  },
  methods: {
    ...mapActions("insentif_salesman", ["triggerModal", "getInsentifSalesman"]),
    ...mapActions("perusahaan", ["getListPerusahaanByAccess"]),
    ...mapActions("depo", ["getListDepo"]),
    ...mapActions("salesman", ["getListSalesman"]),
    _months() {
      moment.locale("id");
      this.months = moment.months();
    },
    _years() {
      let year = moment().year();
      let years = [];
      for (let i = year; i > year - 3; i--) {
        years.push(i);
      }
      this.years = years;
    },
    _trigger() {
      return this.triggerModal("filter");
    },
    _submit() {
      let year = this.filter.year;
      let month = this.filter.month;
      this.filter.start_date = moment([year, month, 1]).format("YYYY-MM-DD");
      this.filter.end_date = moment(this.filter.start_date)
        .endOf("month")
        .format("YYYY-MM-DD");
      this.getInsentifSalesman();
      this._trigger();
    },
    _getPerusahaan() {
      this.getListPerusahaanByAccess().then((res) => {
        this.response.filter.perusahaans = res;
      });
    },
    _getDepo() {
      let id = this.filter.id_perusahaan;
      this.getListDepo({ id_perusahaan: id }).then((res) => {
        this.response.filter.depos = res;
      });
    },
    _getSalesman() {
      let payload = {
        id_depo: this.filter.id_depo,
        id_perusahaan: this.filter.id_perusahaan,
      };
      this.getListSalesman(payload).then((res) => {
        this.response.filter.salesmans = res;
      });
    },
  },
  mounted() {
    this._getPerusahaan();
    this._months();
    this._years();
  },
  created() {},
};
</script>
